import React, { useEffect, useState } from "react";
import FilterInfo from "./BookModule.module.css";
import {
  Close,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Search,
} from "@mui/icons-material";

export default function FilterTemplate({
  toggleAccordion,
  isOpen,
  ccategory,
  ccourse,
  ssubject,
  category_on,
  course_on,
  subject_on,
  medium_on,
  book_on,
  handlechange,
  handleSearch,
  searchTermCourse,
  searchTermSubject,
  updateChipData,
  handleDelete,
  handleClearAllFilter,
  handleViewFilter,
  Tagsitems,
  selectedTag,
  handleTagSelection,
}) {
  return (
    <fieldset className={`${FilterInfo.FilterContainer} `}>
      <legend className="w-auto mb-0">Filters</legend>
      <div className="col-xl-12 col-lg-12 col-md-12 col-12">
        <ul className={`${FilterInfo.accordion} d-flex flex-column mb-0 px-0`}>
          {" "}
          <li
            className={`${FilterInfo.padding_20_0} pt-0 ${FilterInfo.BookborderRed}`}
          >
            {updateChipData?.length === 1 ? (
              <div className="col-md-12 d-flex justify-content-between pb-0  padding_10_0">
                <p className={`${FilterInfo.noFilter} mb-0`}>
                  No Filters Applied
                </p>
              </div>
            ) : (
              <>
                <div className="mb-2 col-xl-12 col-lg-12 col-md-12 col-12 d-flex justify-content-end ">
                  <p
                    onClick={handleClearAllFilter}
                    className={`${FilterInfo.clearFilter} mb-0`}
                  >
                    CLEAR ALL FILTERS
                  </p>
                </div>
                <div className="col-xl-12 col-lg-12 col-md-12 d-flex  pb-0 pt-0 padding_10_0">
                  <ul
                    className={` px-0 mx-0 d-flex flex-wrap ${FilterInfo.BookTagchip}`}
                  >
                    {updateChipData?.map(
                      (yu, ind) =>
                        yu.name && ( // Check if yu.name is truthy
                          <li
                            key={ind}
                            style={{ display: "flex" }}
                            className={FilterInfo.liChipFilter}
                          >
                            <a
                              href="javascript:void(0)"
                              className={` p-0 ${FilterInfo.BookTagChipLabel1}`}
                                title= {yu.name}
                            >
                              {yu.name}{" "}
                            </a>
                            <Close
                              onClick={() => handleDelete(yu)}
                              className={FilterInfo.closeFilterIcon}
                            />
                          </li>
                        ) // Render nothing if yu.name is falsy
                    )}
                  </ul>
                </div>
              </>
            )}
          </li>
          <li
            onClick={() => toggleAccordion("Category")}
            className={`${FilterInfo.padding_20_0} ${FilterInfo.BookborderRed}`}
          >
            <div className="col-md-12 d-flex justify-content-between ">
              <a href="javascript:void(0)" className={FilterInfo.accordionItem}>
                Category
              </a>
              {isOpen.category ? (
                <KeyboardArrowUp className={FilterInfo.arrow_icons} />
              ) : (
                <KeyboardArrowDown className={FilterInfo.arrow_icons} />
              )}
            </div>
            {isOpen.category && (
              <div className="col-md-12 ">
                <ul className={`${FilterInfo.filterContent} mx-0 px-0`}>
                  {ccategory.map((eo) => (
                    <li
                      className="padding_10_0 pb-0"
                      onClick={(e) => {
                        e.stopPropagation();
                        handlechange(
                          { target: { value: eo.value, name: eo.label } },
                          "category_section"
                        );
                      }}
                    >
                      <input
                        className={`${FilterInfo.radip_input} cursorPnt`}
                        type="radio"
                        name={eo.label}
                        id={eo.label}
                        value={eo.value}
                        checked={category_on.some(
                          (element) => element.id == eo.value
                        )}
                        onChange={(e) => handlechange(e, "category_section")}
                        onClick={(e) => e.stopPropagation()}
                      />
                      <label
                        htmlFor={eo.label}
                        onClick={(e) => e.stopPropagation()} // Stops propagation of the click to parent elements
                        className={`${FilterInfo.filterContentItem} ${FilterInfo.padding_0_10} cursorPnt`}
                      >
                        {eo.label}
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </li>
          <li
            onClick={() => toggleAccordion("Course")}
            className={` ${FilterInfo.padding_20_0} ${FilterInfo.BookborderRed}`}
          >
            <div className="d-flex justify-content-between ">
              <a href="javascript:void(0)" className={FilterInfo.accordionItem}>
                {" "}
                Course
              </a>
              {isOpen.course ? (
                <KeyboardArrowUp className={FilterInfo.arrow_icons} />
              ) : (
                <KeyboardArrowDown className={FilterInfo.arrow_icons} />
              )}
            </div>
            {isOpen.course && (
              <>
                <div
                  className={`${FilterInfo.searchInputSec} padding_10_0 pb-0 col-md-12`}
                >
                  <input
                    className={`${FilterInfo.searchInput} w-100`}
                    type="text"
                    placeholder="Search course here..."
                    name="search_course"
                    value={searchTermCourse}
                    onChange={(e) => handleSearch(e, "course_section")}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <Search
                    className={`${FilterInfo.searchIcon} cursorPnt`}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>

                <div className={`padding_10_0 col-md-12`}>
                  <ul className={`${FilterInfo.filterContent}  mx-0 px-0`}>
                    {ccourse?.length > 0 &&
                      ccourse?.map((er) => (
                        <li
                          className="padding_10_0 pb-0 filterListData"
                          onClick={(e) => {
                            e.stopPropagation();
                            handlechange(
                              {
                                target: {
                                  value: er.value,
                                  name: er.label,
                                  checked: !course_on.some(
                                    (element) => element.id == er.value
                                  ), // Toggle checked state
                                },
                              },
                              "course_section",er
                            );
                          }}
                        >
                          <input
                            class={`${FilterInfo.radip_input} cursorPnt`}
                            type="checkbox"
                            name={er.label}
                           id={`course_${er.value}`}
                            value={er.value}
                            checked={course_on.some(
                              (element) => element.id == er.value
                            )}
                            onChange={(e) => handlechange(e, "course_section",er)}
                            onClick={(e) => e.stopPropagation()}
                          />
                          <label
                            // htmlFor={er.label}
                               htmlFor={`course_${er.value}`}
                            onClick={(e) => e.stopPropagation()}
                            className={`${FilterInfo.filterContentItem} ${FilterInfo.padding_0_10} cursorPnt`}
                          >
                            {er.label}
                          </label>
                        </li>
                      ))}
                  </ul>
                </div>
              </>
            )}
          </li>
          <li
            onClick={() => toggleAccordion("Subject")}
            className={` ${FilterInfo.padding_20_0} ${FilterInfo.BookborderRed}`}
          >
            <div className="d-flex justify-content-between ">
              <a href="javascript:void(0)" className={FilterInfo.accordionItem}>
                Subject
              </a>

              {isOpen.Subject ? (
                <KeyboardArrowUp className={FilterInfo.arrow_icons} />
              ) : (
                <KeyboardArrowDown className={FilterInfo.arrow_icons} />
              )}
            </div>
            <div>
              <a
                href="javascript:void(0)"
                className={FilterInfo.accordionItem}
                style={{ fontWeight: "unset", opacity: "0.6" }}
              >
                (Subjects will be displayed based on your selected category and
                course)
              </a>
            </div>
            {isOpen.Subject && (
              <>
                <div
                  className={`${FilterInfo.searchInputSec} col-md-12 padding_10_0 pb-0`}
                >
                  <input
                    className={`${FilterInfo.searchInput} w-100`}
                    type="text"
                    // placeholder="Search subject here..."
                    placeholder="Search subject here"
                    name="search_subject"
                    value={searchTermSubject}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => handleSearch(e, "subject_section")}
                  />
                  <Search
                    className={`${FilterInfo.searchIcon}`}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>

                <div className={`padding_10_0 col-md-12`}>
                  <ul className={`${FilterInfo.filterContent}  mx-0 px-0`}>
                    {ssubject?.length > 0 &&
                      ssubject?.map((er) => (
                        <li
                          className="padding_10_0 pb-0 filterListData"
                          onClick={(e) => {
                            e.stopPropagation();
                            handlechange(
                              {
                                target: {
                                  value: er.value,
                                  name: er.label,
                                  checked: !subject_on.some(
                                    (element) => element.id == er.value
                                  ), // Toggle checked state
                                },
                              },
                              "subject_section"
                            );
                          }}
                        >
                          <input
                            class={`${FilterInfo.checkBox_input} cursorPnt`}
                            type="checkbox"
                            name={er.label}
                            id={er.label}
                            value={er.value}
                            checked={subject_on.some(
                              (element) => element.id == er.value
                            )}
                            onChange={(e) => handlechange(e, "subject_section")}
                            onClick={(e) => e.stopPropagation()}
                          />
                          <label
                            htmlFor={er.label}
                            className={`${FilterInfo.filterContentItem} ${FilterInfo.padding_0_10} cursorPnt`}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {er.label}
                          </label>
                        </li>
                      ))}
                  </ul>
                </div>
              </>
            )}
          </li>
          <li
            onClick={() => toggleAccordion("Medium")}
            className={`${FilterInfo.padding_20_0} ${FilterInfo.BookborderRed}`}
          >
            <div className="d-flex justify-content-between ">
              <a href="javascript:void(0)" className={FilterInfo.accordionItem}>
                Medium
              </a>
              {isOpen.Medium ? (
                <KeyboardArrowUp className={FilterInfo.arrow_icons} />
              ) : (
                <KeyboardArrowDown className={FilterInfo.arrow_icons} />
              )}
            </div>
            {isOpen.Medium && (
              <div className="col-md-12 ">
                <ul className={`${FilterInfo.filterContent} mx-0 px-0`}>
                  <li
                    className="padding_10_0"
                    onClick={(e) => {
                      e.stopPropagation();
                      handlechange(
                        { target: { value: 0, name: "Tamil Medium" } },
                        "medium_section"
                      );
                    }}
                  >
                    <input
                      class={`${FilterInfo.radip_input} cursorPnt`}
                      type="radio"
                      name={"Tamil Medium"}
                      id="tamil_medium"
                      value={0}
                      checked={medium_on.some((element) => element.id == 0)}
                      onChange={(e) => handlechange(e, "medium_section")}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <label
                      onClick={(e) => e.stopPropagation()}
                      htmlFor="tamil_medium"
                      className={`${FilterInfo.filterContentItem} ${FilterInfo.padding_0_10} cursorPnt`}
                    >
                      Tamil
                    </label>
                  </li>
                  <li
                    className="padding_10_0"
                    onClick={(e) => {
                      e.stopPropagation();
                      handlechange(
                        { target: { value: 1, name: "English Medium" } },
                        "medium_section"
                      );
                    }}
                  >
                    <input
                      class={`${FilterInfo.radip_input} cursorPnt`}
                      type="radio"
                      name={"English Medium"}
                      id="english_medium"
                      value={1}
                      checked={medium_on.some((element) => element.id == 1)}
                      onChange={(e) => handlechange(e, "medium_section")}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <label
                      onClick={(e) => e.stopPropagation()}
                      htmlFor="english_medium"
                      className={`${FilterInfo.filterContentItem} ${FilterInfo.padding_0_10} cursorPnt`}
                    >
                      English
                    </label>
                  </li>
                  <li
                    className="padding_10_0"
                    onClick={(e) => {
                      e.stopPropagation();
                      handlechange(
                        { target: { value: 1, name: "Both" } },
                        "medium_section"
                      );
                    }}
                  >
                    <input
                      class={`${FilterInfo.radip_input} cursorPnt`}
                      type="radio"
                      name={"Both"}
                      id="both"
                      value={2}
                      checked={medium_on.some((element) => element.id == 2)}
                      onChange={(e) => handlechange(e, "medium_section")}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <label
                      onClick={(e) => e.stopPropagation()}
                      htmlFor="both"
                      className={`${FilterInfo.filterContentItem} ${FilterInfo.padding_0_10} cursorPnt`}
                    >
                      Both
                    </label>
                  </li>
                </ul>
              </div>
            )}
          </li>
          <li
            onClick={() => toggleAccordion("book_selection")}
            className={` ${FilterInfo.padding_20_0} ${FilterInfo.BookborderRed}`}
          >
            <div className="d-flex justify-content-between ">
              <a href="javascript:void(0)" className={FilterInfo.accordionItem}>
                Book Type
              </a>
              {isOpen.book_selection ? (
                <KeyboardArrowUp className={FilterInfo.arrow_icons} />
              ) : (
                <KeyboardArrowDown className={FilterInfo.arrow_icons} />
              )}
            </div>
            {isOpen.book_selection && (
              <div className="col-md-12 ">
                <ul className={`${FilterInfo.filterContent} mx-0 px-0`}>
                  <li
                    className="padding_10_0"
                    onClick={(e) => {
                      e.stopPropagation();
                      handlechange(
                        { target: { value: 0, name: "Individual Books" } },
                        "book_section"
                      );
                    }}
                  >
                    <input
                      class={`${FilterInfo.radip_input} cursorPnt`}
                      type="radio"
                      name={"Individual Books"}
                      id="Individual_Books"
                      value={0}
                      checked={book_on.some(
                        (element) =>
                          element.id == 0 && element.name == "Individual Books"
                      )}
                      onChange={(e) => handlechange(e, "book_section")}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <label
                      htmlFor="Individual_Books"
                      onClick={(e) => e.stopPropagation()}
                      className={`${FilterInfo.filterContentItem} ${FilterInfo.padding_0_10} cursorPnt`}
                    >
                      Individual Books
                    </label>
                  </li>
                  <li
                    className="padding_10_0"
                    onClick={(e) => {
                      e.stopPropagation();
                      handlechange(
                        { target: { value: 1, name: "Booksets" } },
                        "book_section"
                      );
                    }}
                  >
                    <input
                      class={`${FilterInfo.radip_input} cursorPnt`}
                      type="radio"
                      name={"Booksets"}
                      id="Bookset"
                      value={1}
                      checked={book_on.some(
                        (element) =>
                          element.id == 1 && element.name == "Booksets"
                      )}
                      onChange={(e) => handlechange(e, "book_section")}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <label
                      htmlFor="Bookset"
                      onClick={(e) => e.stopPropagation()}
                      className={`${FilterInfo.filterContentItem} ${FilterInfo.padding_0_10} cursorPnt`}
                    >
                      Booksets
                    </label>
                  </li>
                  <li
                    className="padding_10_0"
                    onClick={(e) => {
                      e.stopPropagation();
                      handlechange(
                        { target: { value: 2, name: "E-Books" } },
                        "book_section"
                      );
                    }}
                  >
                    <input
                      class={`${FilterInfo.radip_input} cursorPnt`}
                      type="radio"
                      name={"E-Books"}
                      id="eBook"
                      value={2}
                      checked={book_on.some(
                        (element) =>
                          element.id == 2 && element.name == "E-Books"
                      )}
                      onChange={(e) => handlechange(e, "book_section")}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <label
                      htmlFor="eBook"
                      onClick={(e) => e.stopPropagation()}
                      className={`${FilterInfo.filterContentItem} ${FilterInfo.padding_0_10} cursorPnt`}
                    >
                      E-Books
                    </label>
                  </li>
                  <li
                    className="padding_10_0"
                    onClick={(e) => {
                      e.stopPropagation();
                      handlechange(
                        { target: { value: 1, name: "Combo Offers" } },
                        "book_section"
                      );
                    }}
                  >
                    <input
                      class={`${FilterInfo.radip_input} cursorPnt`}
                      type="radio"
                      name={"Combo Offers"}
                      id="comboOffer"
                      value={3}
                      checked={book_on.some(
                        (element) =>
                          element.id == 3 && element.name == "Combo Offers"
                      )}
                      onChange={(e) => handlechange(e, "book_section")}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <label
                      htmlFor="comboOffer"
                      onClick={(e) => e.stopPropagation()}
                      className={`${FilterInfo.filterContentItem} ${FilterInfo.padding_0_10} cursorPnt`}
                    >
                      Combo Offers
                    </label>
                  </li>
                </ul>
              </div>
            )}
          </li>
          <li
            onClick={() => toggleAccordion("book_tags")}
            className={` ${FilterInfo.padding_20_0} `}
          >
            <div className="d-flex justify-content-between ">
              <a href="javascript:void(0)" className={FilterInfo.accordionItem}>
                Book Series
              </a>
              {isOpen.book_tags ? (
                <KeyboardArrowUp className={FilterInfo.arrow_icons} />
              ) : (
                <KeyboardArrowDown className={FilterInfo.arrow_icons} />
              )}
            </div>
            {isOpen.book_tags && (
              <div
                className={`px-0 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 `}
              >
                <ul className={` p-0 m-0  ${FilterInfo.BookTagchip}`}>
                  {Array.isArray(Tagsitems) && (
                    <>
                      {Tagsitems?.slice(0, 8).map((op, index) => (
                        <>
                          <li
                            className="padding_10_0"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleTagSelection(op.tag_id, op.tag_name);
                            }}
                          >
                            <input
                              class={`${FilterInfo.radip_input} cursorPnt`}
                              type="radio"
                              name={op.tag_name}
                              id={op.tag_name}
                              value={op.tag_id}
                              checked={selectedTag === op.tag_id}
                              onChange={() =>
                                handleTagSelection(op.tag_id, op.tag_name)
                              }
                              onClick={(e) => e.stopPropagation()}
                            />
                            <label
                              htmlFor={op.tag_name}
                              onClick={(e) => e.stopPropagation()}
                              className={`${FilterInfo.filterContentItem} ${FilterInfo.padding_0_10} cursorPnt`}
                            >
                              {op.tag_name}
                            </label>
                          </li>
                        </>
                      ))}
                    </>
                  )}
                </ul>
              </div>
            )}
          </li>
        </ul>
      </div>
    </fieldset>
  );
}
